<div
  class="tw-flex tw-flex-col tw-gap-3 tw-items-center tw-justify-center tw-px-6 tw-py-5 tw-border tw-border-color-border-subtle tw-rounded-xl tw-cursor-pointer hover:tw-bg-color-surface-elevated tw-transition-colors"
>
  <img
    [src]="plugin.imagePath"
    [alt]="plugin.displayName"
    class="tw-h-12 tw-w-12 tw-object-contain"
  />
  <span class="tw-text-center tw-text-sm">{{ plugin.displayName }}</span>
</div>
